<template>
  <el-container>
    <el-header style="height: 100%" class="header-container">
      <div>
        <el-button icon="el-icon-arrow-left" @click="$router.back()"></el-button>
        <span style="font-size: large;margin-left: 20px">域名组管理</span>
      </div>
    </el-header>
    <el-main>
      <div class="group-container">
        <div class="action-bar">
          <el-button type="primary" size="medium" @click="handleAddGroup">{{ $t('添加域名组') }}</el-button>
        </div>
        <el-form :inline="true" :model="searchForm">
          <el-form-item :label="$t('组名')">
            <el-input v-model="searchForm.name" :placeholder="$t('请输入组名')"
                      clearable
                      @clear="handleSearchClear"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">{{ $t('domainList.search') }}</el-button>
            <el-button @click="resetSearch">{{ $t('domainList.reset') }}</el-button>
          </el-form-item>
        </el-form>
        <el-table
            :data="groupData"
            border
            style="width: 100%"
            v-loading="loading"
        >
          <el-table-column fixed prop="id" label="ID" width="50"></el-table-column>
          <el-table-column prop="name" label="组名称" min-width="120"></el-table-column>
          <el-table-column prop="description" label="备注" min-width="120"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template v-slot="scope" >
              <el-button type="text" size="small" @click="handleEditGroup(scope.row)">
                编辑
              </el-button>
              <el-button type="text" size="small" class="delete-btn" @click="handleDeleteGroup(scope.row)">
                {{ $t('删除') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total">
          </el-pagination>
        </div>
        <el-dialog :title="groupFromType === 'add' ? $t('添加域名组') : $t('编辑域名组')"
                   :visible.sync="groupFromVisible"
                   append-to-body
        >
          <el-form ref="groupForm" :model="groupForm" :rules="formRules" label-width="80px">
            <el-form-item label="组名称" prop="name">
              <el-input v-model="groupForm.name"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="description">
              <el-input v-model="groupForm.description"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="groupFromVisible = false">取消</el-button>
            <el-button type="primary" @click="submitGroupForm">确定</el-button>
          </div>
        </el-dialog>
      </div>
    </el-main>
  </el-container>

</template>

<script>
  export default {
    name: 'group',
    data() {
      return {
        activeMenu: '',
        groupData: [],
        loading: false,
        pagination : {
          total: 0,
          currentPage: 1,
          pageSize: 10
        },
        groupFromVisible : false,
        groupForm : {
          id : null,
          name : '',
          description : ''
        },
        formRules : {
          name : [
            {required: true, message: '请输入组名称', trigger: 'blur'}
          ]
        },
        groupFromType : '',
        searchForm : {
          name : ''
        }


      }
    },
    created() {
      this.getGroupList()
    },
    methods: {
      getGroupList() {
        this.loading = true
        this.axios.post('/admin/data/domainGroupList',{
          currentPage : this.pagination.currentPage,
          pageSize : this.pagination.pageSize,
          search : this.searchForm
        },{
          token : true
        }).then(res => {
          console.log('getGroupList')
          console.log(res)
          if(res.status === 200 && res.data && res.data.code === 1){
            this.groupData = res.data.data.list.list
            this.pagination.total = res.data.data.list.total
          }else {
            this.$message.error(res.data.msg)
          }
        }).finally(() => {
          this.loading = false
        })
      },
      // 处理每页条数变化
      handleSizeChange(val) {
        this.pagination.pageSize = val
        this.pagination.currentPage = 1
        this.getGroupList()
      },
      // 处理页码变化
      handleCurrentChange(val) {
        this.pagination.currentPage = val
        this.getGroupList()
      },
      handleAddGroup(){
        this.groupFromType = 'add'
        this.resetGroupForm()
        this.groupFromVisible = true
      },
      resetGroupForm(){
        this.groupForm = {
          id : null,
          name : '',
          description : ''
        }
      },
      submitGroupForm(){
        this.$refs.groupForm.validate(valid => {
          if(valid){
            this.loading = true
            const apiUrl = this.groupFromType === 'add'
                ? '/admin/data/addDomainGroup'
                : '/admin/data/editDomainGroup'
            this.axios.post(apiUrl,this.groupForm,{
              token : true
            }).then(res => {
              console.log('submitGroupForm')
              console.log(res)
              if(res.status === 200 && res.data && res.data.code === 1){
                this.$message.success(res.data.msg)
              }
            }).catch(error => {
              this.$message.error(error)
            }).finally(() => {
              this.getGroupList()
              this.loading = false
              this.groupFromVisible = false
            })
          }
        })
      },
      handleEditGroup(group){
        this.resetGroupForm()
        this.groupFromType = 'edit'
        this.groupForm = {
          ...group
        }
        this.groupFromVisible = true
      },
      handleDeleteGroup(group){
        this.$confirm(this.$t('确定删除这条域名分组吗？'), this.$t('提示'), {
          confirmButtonText: this.$t('确定'),
          cancelButtonText: this.$t('取消'),
          type: 'warning'
        }).then(() => {
          this.axios.post('/admin/data/deleteDomainGroup',{
            id : group.id
          },{
            token : true
          }).then(res => {
            if(res.status === 200 && res.data && res.data.code === 1){
              this.$message.success(res.data.msg)
            }else {
              this.$message.error(res.data.msg)
            }
          }).catch(error => {
            this.$message.error(error)
          }).finally(() => {
            this.getGroupList()
          })
        })
      },
      handleSearch(){
        this.pagination.currentPage = 1
        this.getGroupList()
      },
      resetSearch(){
        this.searchForm = {
          name : ''
        }
        this.getGroupList()
      },
      handleSearchClear(){
        this.getGroupList()
      }
    }


  }
</script>
<style scoped>
.action-bar {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
.delete-btn {
  color: #F56C6C;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>